import { Subject } from 'rxjs';
import Watermark from '@/model/Watermark';

const uploadReq$ = new Subject<{
    sessionId: string,
    finalizationMode: boolean,
    files: Array<{file: File; id?: string}>,
    watermark: Watermark,
}>();

export default uploadReq$;
